import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#1A1513', borderTop: '1px solid #362B25' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="/logo-header.png" 
              alt="Eman's Peppers" 
              width="64"
              height="64"
              loading="lazy"
              className="h-16 w-auto mb-6"
            />
            <p className="text-sm leading-relaxed" style={{ color: '#B5A79E', fontFamily: 'Manrope, sans-serif' }}>
              Premium quality peptides for research and wellness optimization. Committed to excellence and scientific integrity.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-medium mb-6" style={{ color: '#F7F3EE', fontFamily: 'Playfair Display, serif' }}>
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/products" 
                  className="text-sm transition-colors hover:text-[#D4A373]"
                  style={{ color: '#B5A79E', fontFamily: 'Manrope, sans-serif' }}
                >
                  Products
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className="text-sm transition-colors hover:text-[#D4A373]"
                  style={{ color: '#B5A79E', fontFamily: 'Manrope, sans-serif' }}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/faq" 
                  className="text-sm transition-colors hover:text-[#D4A373]"
                  style={{ color: '#B5A79E', fontFamily: 'Manrope, sans-serif' }}
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-sm transition-colors hover:text-[#D4A373]"
                  style={{ color: '#B5A79E', fontFamily: 'Manrope, sans-serif' }}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-lg font-medium mb-6" style={{ color: '#F7F3EE', fontFamily: 'Playfair Display, serif' }}>
              Customer Service
            </h3>
            <ul className="space-y-3">
              <li className="text-sm" style={{ color: '#B5A79E' }}>
                Shipping & Delivery
              </li>
              <li className="text-sm" style={{ color: '#B5A79E' }}>
                Returns & Refunds
              </li>
              <li className="text-sm" style={{ color: '#B5A79E' }}>
                Privacy Policy
              </li>
              <li className="text-sm" style={{ color: '#B5A79E' }}>
                Terms of Service
              </li>
            </ul>
          </div>

          {/* Discord Community */}
          <div>
            <h3 className="text-lg font-medium mb-6" style={{ color: '#F7F3EE', fontFamily: 'Playfair Display, serif' }}>
              Join Our Community
            </h3>
            <div className="p-4 rounded" style={{ backgroundColor: 'rgba(212, 163, 115, 0.1)', border: '1px solid rgba(212, 163, 115, 0.3)' }}>
              <div className="flex items-center gap-2 mb-3">
                <svg className="w-6 h-6" viewBox="0 0 71 55" fill="#D4A373">
                  <path d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z"/>
                </svg>
                <span className="text-sm font-bold uppercase tracking-wider" style={{ color: '#D4A373' }}>
                  Discord Server
                </span>
              </div>
              <p className="text-sm mb-3" style={{ color: '#B5A79E' }}>
                Join for <span style={{ color: '#D4A373', fontWeight: '600' }}>secret flash sales</span> 🤫
              </p>
              <a 
                href="https://discord.gg/9NfmAQusF" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block px-4 py-2 rounded text-sm font-medium transition-all hover:scale-105"
                style={{ backgroundColor: '#5865F2', color: '#ffffff' }}
              >
                Join Server
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-medium mb-6" style={{ color: '#F7F3EE', fontFamily: 'Playfair Display, serif' }}>
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#D4A373' }} />
                <a 
                  href="mailto:CMpeppersofficial@gmail.com" 
                  className="text-sm transition-colors hover:text-[#D4A373]"
                  style={{ color: '#B5A79E' }}
                >
                  CMpeppersofficial@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#D4A373' }} />
                <span className="text-sm" style={{ color: '#B5A79E' }}>
                  Available via email
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="pt-8 mb-8" style={{ borderTop: '1px solid #362B25' }}>
          <p className="text-xs leading-relaxed text-center max-w-4xl mx-auto" style={{ color: '#B5A79E' }}>
            <strong style={{ color: '#D4A373' }}>RESEARCH USE ONLY:</strong> All products sold by CM Peptides are intended strictly for laboratory research purposes only. These products are not drugs, dietary supplements, or food additives, and are not intended for human consumption, therapeutic use, or clinical application. By accessing this site, you acknowledge that you are a qualified research professional and will use products only for lawful research purposes.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4" style={{ borderTop: '1px solid #362B25' }}>
          <p className="text-sm" style={{ color: '#B5A79E', fontFamily: 'Manrope, sans-serif' }}>
            © {currentYear} CM Peptides. All rights reserved.
          </p>
          <p className="text-xs" style={{ color: '#B5A79E' }}>
            Designed for research professionals
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
